import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Layout from './components/Layout/Layout'

import PreviewGame from './pages/PreviewGame'
import EditGame from './pages/EditGame'
import AddGame from './pages/AddGame'
import DeleteGame from './pages/DeleteGame'

import PreviewOrder from './pages/PreviewOrder'
import DeleteOrder from './pages/DeleteOrder'
import AddOrder from './pages/AddOrder'
import EditOrder from './pages/EditOrder';

import PreviewFaq from './pages/PreviewFaq';
import DeleteFaq from './pages/DeleteFaq';
import AddFaq from './pages/AddFaq';
import EditFaq from './pages/EditFaq';

import PreviewCategory from './pages/PreviewCategory';
import DeleteCategory from './pages/DeleteCategory';
import AddCategory from './pages/AddCategory';
import EditCategory from './pages/EditCategory';

import './assets/css/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'

const App = () => {
    return (
        <>
            <Router>
                <Layout>
                    <Switch>

                        <Route path="/" exact component={PreviewGame} />
                        <Route path="/edit-game/:id" exact component={EditGame} />
                        <Route path="/add-game" exact component={AddGame} />
                        <Route path="/delete-game/:id" exact component={DeleteGame} />

                        <Route path="/preview-order" exact component={PreviewOrder} />
                        <Route path="/delete-order/:id" exact component={DeleteOrder} />
                        <Route path="/add-order" exact component={AddOrder} />
                        <Route path="/edit-order/:id" exact component={EditOrder} />

                        <Route path="/preview-faq" exact component={PreviewFaq} />
                        <Route path="/delete-faq/:id" exact component={DeleteFaq} />
                        <Route path="/add-faq" exact component={AddFaq} />
                        <Route path="/edit-faq/:id" exact component={EditFaq} />

                        <Route path="/preview-category" exact component={PreviewCategory} />
                        <Route path="/delete-category/:id" exact component={DeleteCategory} />
                        <Route path="/add-category" exact component={AddCategory} />
                        <Route path="/edit-category/:id" exact component={EditCategory} />
                    </Switch>
                </Layout>
            </Router>
        </>
    )
}

export default App